/**
 * OAuth Configuration for miniOrange OAuth Server
 */

const OAUTH_CONFIG = {
  // WordPress site URL (without trailing slash)
  wordpressUrl: process.env.REACT_APP_WORDPRESS_URL || "https://vplaysmart.com",

  // OAuth Client credentials (from WordPress OAuth Server plugin)
  clientId: process.env.REACT_APP_CLIENT_ID || "your_client_id_here",
  clientSecret:
    process.env.REACT_APP_CLIENT_SECRET || "your_client_secret_here",

  // Redirect URIs (automatically uses current domain)
  get redirectUri() {
    return `${window.location.origin}/oauth/callback`;
  },

  get silentRedirectUri() {
    return `${window.location.origin}/oauth/silent-callback`;
  },

  // miniOrange OAuth Endpoints
  get authorizationEndpoint() {
    return `${this.wordpressUrl}/wp-json/moserver/authorize`;
  },

  get tokenEndpoint() {
    return `${this.wordpressUrl}/wp-json/moserver/token`;
  },

  get userInfoEndpoint() {
    return `${this.wordpressUrl}/wp-json/moserver/resource`;
  },

  // OAuth settings for miniOrange
  scope: "openid profile email",
  responseType: "code",

  // Detect if running in iframe
  isEmbedded: window.self !== window.top,
};

export default OAUTH_CONFIG;
